var map = {
	"./biology/questions/biology/AQA-84641B1H-paper.json": 350,
	"./biology/questions/biology/AQA-84642B2H-paper.json": 3402,
	"./biology/questions/biology/AQA-8464B1H-JUN18-paper.json": 2892,
	"./biology/questions/biology/AQA-8464B2H-JUN18-paper.json": 1147,
	"./biology/questions/biology/AQA-8464B2H-JUN19-paper.json": 3228,
	"./biology/questions/biology/AQA-8464B2H-JUN22-paper.json": 98,
	"./biology/questions/biology/AQA-8464B2H-JUN23-paper.json": 3705,
	"./biology/questions/biology/AQA-8464B2H-JUN24-paper.json": 4040,
	"./biology/questions/biology/AQA-8464B2H-NOV20-paper.json": 7102,
	"./biology/questions/biology/AQA-8464B2H-NOV21-paper.json": 8085,
	"./chemistry/questions/chemistry/AQA-8464C1H-JUN18-paper.json": 8283,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN18-paper.json": 2444,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN19-paper.json": 363,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN22-paper.json": 2777,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN23-paper.json": 3618,
	"./chemistry/questions/chemistry/AQA-8464C2H-JUN24-paper.json": 2743,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV20-paper.json": 8673,
	"./chemistry/questions/chemistry/AQA-8464C2H-NOV21-paper.json": 5482,
	"./physics/questions/physics/AQA-84645P1H-paper.json": 2556,
	"./physics/questions/physics/AQA-84646P2H-paper.json": 3156,
	"./physics/questions/physics/AQA-8464P2H-JUN22-paper.json": 7608,
	"./physics/questions/physics/AQA-8464P2H-JUN23-paper.json": 1943,
	"./physics/questions/physics/AQA-8464P2H-JUN24-paper.json": 9490,
	"./physics/questions/physics/AQA-8464P2H-NOV20-paper.json": 1828,
	"./physics/questions/physics/AQA-8464P2H-NOV21-paper.json": 419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5606;